import React, { useEffect, useState } from 'react';
import { IconButton, Menu, MenuItem, Typography } from '@mui/material';
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { SCUICustomDataGrid } from '../../../../atomic/molecules';
import GlobalDataQuery from '../../../../services/query/globaldata/GlobalDataQuery.services';
import CopyToClipboardButton from '../../../../atomic/atoms/SCUICopyToClipboardButton/SCUICopyToClipboardButton';
import { GlobaldataCommand } from '../../../../services/command';
import RefreshIcon from '@mui/icons-material/Refresh';
import DeleteIcon from '@mui/icons-material/Delete';
import { GDT } from '../globalDataTokenManagement.classes';

const GlobalDataTokenGrid = ({ setTokenName, refresh, reGenerateToken }: any) => {
    const { t } = useTranslation();
    const [tokenDatas, seTokenDatas] = useState([]);
    useEffect(() => {
        GetGlobalDataToken();
    }, [refresh]);
    const GetGlobalDataToken = () => {
        GlobalDataQuery.GetGlobalDataToken()
            .then((res: any) => {
                if (res?.model) {
                    seTokenDatas(res.model);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };
    const handleDeleteToken = async (id: any) => {
        const result = await Swal.fire({
            title: 'Token ı silmek istediğinizden emin misiniz?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sil',
            cancelButtonText: 'Vazgeç',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
        });

        if (!result.isConfirmed) {
            return;
        }

        const res = await GlobaldataCommand.DeleteGlobaldataToken(id);
        if (res) {
            await Swal.fire(t('general.success'), 'Silindi', 'success');
            GetGlobalDataToken();
        }
    };

    const columns = [
        {
            field: 'tokenName',
            headerName: t('globaldatatokenmanagement.tokenName'),
            flex: 1,
            headerAlign: 'center',
            align: 'left',
            renderCell: (params: any) => (
                <span
                    className={GDT.cellTokenName}
                    data-token-id={params.row?.id}
                    data-token-name={params.row?.tokenName}
                >
                    {params.value}
                </span>
            ),
        },
        {
            field: 'tokenKey',
            headerName: t('globaldatatokenmanagement.tokenValue'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => {
                return (
                    <div
                        className={GDT.cellTokenKey}
                        data-token-id={params.row?.id}
                        data-token-key={params.value}
                        style={{ display: 'flex', alignItems: 'center' }}
                    >
                        <span className={GDT.cellTokenKeyText}>
                            {params.value?.substring(0, 10).concat('...') +
                                params.value?.substring(params.value.length - 10, params.value.length)}
                        </span>
                        <CopyToClipboardButton textToCopy={params.value} />
                    </div>
                );
            },
        },
        {
            field: 'createdBy',
            headerName: t('globaldatatokenmanagement.createdBy'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => (
                <span
                    className={GDT.cellCreatedBy}
                    data-token-id={params.row?.id}
                    data-created-by={params.value}
                >
                    {params.value}
                </span>
            ),
        },
        {
            field: 'deneme ',
            headerName: '',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            maxWidth: 50,
            renderCell: (params: any) => {
                const handleClick = (popupState: any, tur: string) => {
                    popupState.close();
                    switch (tur) {
                        case 'refresh': {
                            setTokenName(params.row);
                            reGenerateToken(params.row);
                            break;
                        }
                        case 'delete': {
                            handleDeleteToken(params.row.id);
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                };
                return (
                    <PopupState variant="popover" popupId="demo-popup-menu">
                        {(popupState: any) => (
                            <React.Fragment>
                                <IconButton
                                    {...bindTrigger(popupState)}
                                    className={GDT.btnRowMenu}
                                    data-token-id={params.row?.id}
                                >
                                    <MoreVertIcon className="svg_icons" />
                                </IconButton>
                                <Menu
                                    {...bindMenu(popupState)}
                                    className={GDT.rowMenu}
                                    slotProps={{
                                        paper: {
                                            sx: {
                                                width: '150px',
                                                minWidth: '150px',
                                                padding: '4px',
                                                backgroundColor: '#e0f7fa',
                                            },
                                        },
                                    }}
                                >
                                    <MenuItem
                                        className={`${GDT.rowMenuItem} ${GDT.rowMenuItemRefresh}`}
                                        data-action="refresh"
                                        data-token-id={params.row?.id}
                                        onClick={() => handleClick(popupState, 'refresh')}
                                        sx={{ display: 'flex', alignItems: 'center' }}
                                    >
                                        <RefreshIcon
                                            style={{ color: '#90caf9', transform: 'scale(1.5)', marginRight: 8 }}
                                        />
                                        <Typography variant="body2" className={GDT.rowMenuItemText}>
                                            Token&apos;ı yenile
                                        </Typography>
                                    </MenuItem>
                                    <MenuItem
                                        className={`${GDT.rowMenuItem} ${GDT.rowMenuItemDelete}`}
                                        data-action="delete"
                                        data-token-id={params.row?.id}
                                        onClick={() => handleClick(popupState, 'delete')}
                                        sx={{ display: 'flex', alignItems: 'center' }}
                                    >
                                        <DeleteIcon
                                            style={{ color: '#e57373', transform: 'scale(1.5)', marginRight: 8 }}
                                        />
                                        <Typography variant="body2" className={GDT.rowMenuItemText}>
                                            Sil
                                        </Typography>
                                    </MenuItem>
                                </Menu>
                            </React.Fragment>
                        )}
                    </PopupState>
                );
            },
        },
    ];

    return (
        <div style={{ height: 600, width: '100%' }} className={GDT.grid}>
            <SCUICustomDataGrid rows={tokenDatas} columns={columns} />
        </div>
    );
};

export default GlobalDataTokenGrid;
